import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81a32084"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grey_div"
}
const _hoisted_2 = { class: "detail_div" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "position" }
const _hoisted_6 = { class: "details" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  style: {"margin-bottom":"6px"}
}, "身份证照片：", -1))
const _hoisted_17 = {
  key: 0,
  class: "btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_ctx.storeInfo.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.storeInfo.data.name), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.storeInfo.data.gender_name), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, "手机：" + _toDisplayString(_ctx.storeInfo.data.mobile), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, "邮箱：" + _toDisplayString(_ctx.storeInfo.data.email), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, "身份证号：" + _toDisplayString(_ctx.storeInfo.data.id_card), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, "身份证有效期：" + _toDisplayString(_ctx.storeInfo.data.start_time_name) + "-" + _toDisplayString(_ctx.storeInfo.data.end_time_name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_van_image, {
                width: "45%",
                height: "90",
                style: {"margin-right":"8px"},
                src: _ctx.storeInfo.data.positive_detail?.photo_thumb_file
              }, null, 8, ["src"]),
              _createVNode(_component_van_image, {
                width: "143",
                height: "90",
                src: _ctx.storeInfo.data.back_detail?.photo_thumb_file
              }, null, 8, ["src"])
            ])
          ]),
          (_ctx.$route.query.master === 'true')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_van_button, {
                  color: "#3d6eeb",
                  type: "primary",
                  block: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.ADD_PERSON,
              query: {
                userId: _ctx.storeInfo.data.id
              }
            })
          ))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑人员")
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_button, {
                  color: "#FC5820",
                  type: "primary",
                  block: "",
                  onClick: _ctx.deleteUser
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除人员")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}